import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import DialogComp from '../../../Core/Dialog/DialogComp';
import { SecondaryButton } from '../../../Core/Controls/Inputs/Buttons/ButtonModal';
import { formatters, SecondaryCheckbox } from '../../../Core/Controls';
import { deleteFutureUnCompletedSchedules, getAdditionalLinkedEventNames } from '../../../Core/Services/InternalUser/ControllerService/scheduleVehicleService';
import { useToast } from '../../../Core/Hooks/useToast';

const DeleteSchedulesModal = (props) => {
    const [state, setState] = useState({
        isDeleteFuture: false,
        isDeleteJob: false,
        linkedEventMessage: null,
        isLoadingMessage: false
    });

    const { showToastSuccess, showToastError } = useToast();
    const [btnLoader, setBtnLoader] = useState(false);

    useEffect(() => {
        const fetchLinkedEventNames = async () => {
            if (props.scheduleID) {
                setState((st) => ({ ...st, isLoadingMessage: true }));
                try {
                    let res = await getAdditionalLinkedEventNames(props.scheduleID);
                    const raw = res?.data?.message;
                    const message = typeof raw === 'string' ? raw : (typeof raw?.message === 'string' ? raw.message : null);
                    if (message && message.trim() && message.trim().toLowerCase() !== 'success') {
                        setState((st) => ({ ...st, linkedEventMessage: message, isLoadingMessage: false }));
                    } else {
                        setState((st) => ({ ...st, isLoadingMessage: false }));
                    }
                } catch {
                    setState((st) => ({ ...st, isLoadingMessage: false }));
                }
            }
        };
        fetchLinkedEventNames();
    }, [props.scheduleID]);

    const onSelectCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => ({ ...st, [name]: checked }));
    };

    const deleteFutureUnComSchedules = async () => {
        try {
            setBtnLoader(true);
            let data = {
                scheduleVehicleID: props.scheduleVehicleID,
                scheduleEventID: props.scheduleEventID,
                isDeleteFuture: state.isDeleteFuture,
                isDeleteJob: state.isDeleteJob,
                scheduleID: props.scheduleID
            };
            let res = await deleteFutureUnCompletedSchedules(data);
            if (res.success) {
                showToastSuccess('Record deleted successfully');
                setState((st) => ({ ...st, showDelete: false }));
                props.pullApiData();
                props.onClose();
            } else {
                showToastError(res.message);
            }
        } catch (error) {
            showToastError(error?.message || 'Something went wrong');
        } finally {
            setBtnLoader(false);
        }
    };

    return (
        <DialogComp title="Delete" onClose={props.onClose} maxWidth="sm">
            <Grid container spacing={0} style={{ marginTop: -12 }}>
                <Grid item container xs={12} spacing={1}>
                    <Grid item xs={6}>
                        <Typography component="legend">
                            <b> Date Due:{formatters.DateFormatter(props.scheduleDateDue)}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="legend">
                            <b>Event Name:{props.scheduleEventName}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography component="legend">Are you sure you want to delete this record?</Typography>
                    </Grid>
                    {state.isLoadingMessage && (
                        <Grid item xs={12}>
                            <Typography component="legend" style={{ color: '#888', fontStyle: 'italic' }}>
                                Loading linked event info...
                            </Typography>
                        </Grid>
                    )}
                    {!state.isLoadingMessage && state.linkedEventMessage && (
                        <Grid item xs={12}>
                            <Typography
                                component="legend"
                                style={{
                                    color: '#d32f2f',
                                    backgroundColor: '#fff3f3',
                                    border: '1px solid #f5c6cb',
                                    borderRadius: 4,
                                    padding: '8px 12px',
                                    marginTop: 4
                                }}
                            >
                                {state.linkedEventMessage}
                            </Typography>
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <SecondaryCheckbox
                            onChange={onSelectCheckbox}
                            checked={state.isDeleteFuture}
                            name="isDeleteFuture"
                            value={state.isDeleteFuture}
                            label="Delete Future Schedules?"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryCheckbox
                            onChange={onSelectCheckbox}
                            checked={state.isDeleteJob}
                            name="isDeleteJob"
                            value={state.isDeleteJob}
                            label="Delete Job?"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryButton isBtnLoader={btnLoader} onClick={deleteFutureUnComSchedules} fullWidth className="submit_btn">
                            Submit
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryButton onClick={props.onClose} fullWidth className="submit_btn">
                            Cancel
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </DialogComp>
    );
};

export default DeleteSchedulesModal;
